<template>
  <layout-basic>
    <b-container class="mt-3">
      <b-card class="data-card">
        <template v-slot:header>
          <h4 class="mb-0 pt-1 flex-shrink-0 mr-auto">
            Events
          </h4>
          <b-form-checkbox
            v-model="showHidden"
            size="md"
            class="flex-shrink-0 pt-2"
            @change="onHiddenChange"
          >
            Show Hidden
          </b-form-checkbox>
          <b-form-input
            v-model="search"
            v-debounce="debounce"
            placeholder="Search events..."
            class="search-field"
          />
          <b-button
            v-b-modal.event-modal
            class="flex-shrink-0"
            variant="primary"
          >
            + New Event
          </b-button>
          <event-modal
            :item="modalItem"
            @close="onModalClose"
          />
        </template>
        <b-table
          id="events-table"
          striped
          responsive="sm"
          :items="items"
          :fields="fields"
          :sort-by="orderBy"
          :sort-desc="orderDesc"
          no-local-sorting
          @sort-changed="onSortChange"
        >
          <template v-slot:cell(actions)="row">
            <a
              href="#"
              class="table-edit"
              @click="edit(row.item)"
            >
              <i class="fa fa-external-link-alt" />
            </a>
            <a
              href="#"
              class="table-delete"
              @click="deleteEntity(row.item)"
            >
              <i class="fa fa-trash-alt" />
            </a>
          </template>
          <template v-slot:cell(createdAt)="date">
            {{ date.value | formatDate }}
          </template>
        </b-table>
        <div class="d-flex justify-content-center">
          <b-pagination
            v-model="currentPage"
            :total-rows="itemsCount"
            :per-page="perPage"
            aria-controls="events-table"
            @change="onPageChange"
          />
        </div>
      </b-card>
    </b-container>
  </layout-basic>
</template>

<script>
  import LayoutBasic from "@/layouts/LayoutBasic";
  import EventModal from "@/components/EventModal";

  export default {
    name: "Events",
    components: {
      LayoutBasic,
      EventModal
    },
    data() {
      return {
        orderBy: 'name',
        orderDesc: false,
        search: '',
        showHidden: false,
        fields: [
          {key: "name", sortable: true},
          {key: 'createdAt', label: "Date Created", sortable: true},
          {
            key: "actions",
            label: "",
            thClass: "tb-col-narrow"
          }
        ],
        items: [],
        itemsCount: 0,
        perPage: 20,
        currentPage: 1,
        modalItem: null
      };
    },
    created: function () {
      this.getData();
    },
    methods: {
      getData() {
        this.items = [];
        this.$http.get(`events?orderBy=${this.orderBy}&search=${this.search}&orderByDirection=${this.orderDesc ? 'desc' : 'asc'}&searches[hidden]=${this.showHidden}&limit=${this.perPage}&page=${this.currentPage}`)
          .then(response => {
            this.items = response.data.items;
            this.itemsCount = response.data.totalCount;
          })
      },
      onPageChange(page) {
        this.currentPage = page;
        this.getData();
      },
      debounce() {
        this.getData();
      },
      onModalClose() {
        this.getData();
        this.modalItem = null
      },
      onHiddenChange(event) {
        this.currentPage = 1;
        this.showHidden = event;
        this.getData();
      },
      onSortChange(event) {
        this.orderBy = event.sortBy;
        this.orderDesc = event.sortDesc;
        this.getData();
      },
      edit(item) {
        this.modalItem = item;
        this.$bvModal.show('event-modal')
      },
      async deleteEntity(item) {
        let confirmation = await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this event?', {
          okVariant: 'danger',
          okTitle: 'Delete',
        });
        if (!confirmation) return;
        try{
          await this.$http.delete(`events/${item.id}`);
          this.getData();
        }catch(error){
          this.handleErrorResponse(error)
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .data-card .card-body {
    padding: 0px;
  }

  .data-card .card-header {
    padding-left: 12px;
    padding-right: 12px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
    }
  }

  .data-card .card-header > * {
    &:not(:first-child) {
      margin-left: 12px;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  h4 {
    @include media-breakpoint-down(sm) {
      flex-basis: 100%;
      margin-left: 12px;
    }
  }

  .search-field {
    flex-basis: 25%;

    @include media-breakpoint-down(sm) {
      flex-basis: auto;
      flex-grow: 1;
      width: auto;
      order: 1;
    }
  }

  /deep/ .tb-col-narrow {
    width: 75px !important;
  }

  .table-edit {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $info;
    }
  }

  .table-delete {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $danger;
    }
  }
</style>